import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import withAssets from "../../../components/hoc/withAssets";
import { STEP_QUALIFICATION_VIEW, STEP_QUALIFICATION_CREATE } from "../../../constants";
import QualificationsViewStep from "./steps/QualificationsViewStep";
import QualificationsCreateStep from "./steps/QualificationsCreateStep";

class CoursesQualificationsForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      step: STEP_QUALIFICATION_VIEW,
      loadedManualQualificationUuid: ''
    };

    this.loadManualQualification = this.loadManualQualification.bind(this);
    this.handleSetStep = this.handleSetStep.bind(this);
    this.handleSaveManualQualification = this.handleSaveManualQualification.bind(this);
    this.handleLoadManualQualification = this.handleLoadManualQualification.bind(this);
    this.handleClearManualQualification = this.handleClearManualQualification.bind(this);
  }

  componentDidMount() {
    if (this.props.errorActiveQualificationStep) {
      this.setState({
        step: this.props.errorActiveQualificationStep
      });
    }

    if (this.props.errorActiveQualificationId) {
      const manualQualification = this.props.manualQualifications.find(manualQualification => manualQualification.id === this.props.errorActiveQualificationId);

      if (manualQualification) {
        this.loadManualQualification(manualQualification);
      }
    }

    // if (this.props.location.hash) {
    //   this.props.handleScrollToElement(this.props.location.hash.substring(1));
    // }
  }

  componentDidUpdate(prevProps) {
    if (this.props.errorActiveQualificationStep && this.props.errorActiveQualificationStep !== prevProps.errorActiveQualificationStep) {
      this.setState({
        step: this.props.errorActiveQualificationStep
      });
    }

    if (this.props.errorActiveQualificationId && this.props.errorActiveQualificationId !== prevProps.errorActiveQualificationId) {
      const manualQualification = this.props.manualQualifications.find(manualQualification => manualQualification.id === this.props.errorActiveQualificationId);

      if (manualQualification) {
        this.loadManualQualification(manualQualification);
      }
    }

    // if (this.props.location.hash !== prevProps.location.hash) {
    //   this.props.handleScrollToElement(this.props.location.hash.substring(1));
    // }
  }

  loadManualQualification(manualQualification) {
    this.setState({
      loadedManualQualificationUuid: manualQualification.uuid
    });

    this.props.handleSet({
      manualQualificationId: manualQualification.id,
      qualificationTitle_en: manualQualification.title.en,
      qualificationTitle_cy: manualQualification.title.cy,
      qualificationType: manualQualification.type,
      qualificationLevel: new Set(manualQualification.level),
      awardingBody: manualQualification.awardingBody,
    });
  }

  handleSetStep(e, step) {
    e.preventDefault();

    this.setState({
      step: step
    });
  }

  handleSaveManualQualification(e) {
    e.preventDefault();

    const manualQualification = {
      uuid: this.state.loadedManualQualificationUuid || uuidv4(),
      id: this.props.manualQualifications.length + 1,
      title: {
        en: this.props.qualificationTitle_en,
        cy: this.props.qualificationTitle_cy
      },
      type: this.props.qualificationType,
      level: [...this.props.qualificationLevel],
      awardingBody: this.props.awardingBody
    };

    let manualQualifications = this.props.manualQualifications;

    if (this.state.loadedManualQualificationUuid) {
      manualQualifications = manualQualifications.filter(manualQualification => manualQualification.uuid !== this.state.loadedManualQualificationUuid);
    }

    manualQualifications.push(manualQualification);

    this.setState({
      loadedManualQualificationUuid: ''
    });

    this.props.handleSet({
      manualQualifications: manualQualifications,

      // Reset create qualification fields.
      manualQualificationId: '',
      qualificationTitle_en: '',
      qualificationTitle_cy: '',
      qualificationType: '',
      qualificationLevel: new Set(),
      awardingBody: '',
    });
  }

  handleLoadManualQualification(e, manualQualification) {
    e.preventDefault();

    this.loadManualQualification(manualQualification);
  }

  handleClearManualQualification() {
    this.setState({
      loadedManualQualificationUuid: ''
    });

    this.props.handleSet({
      manualQualificationId: '',
      qualificationTitle_en: '',
      qualificationTitle_cy: '',
      qualificationType: '',
      qualificationLevel: new Set(),
      awardingBody: '',
    });
  }

  render() {
    return (
      <Fragment>
        {this.state.step === STEP_QUALIFICATION_VIEW &&
          <QualificationsViewStep
            qualificationId={this.props.qualificationId}
            qualificationLabel={this.props.qualificationLabel}
            qualifications={this.props.qualifications}
            manualQualifications={this.props.manualQualifications}
            manualQualificationId={this.props.manualQualificationId}
            unknownQualifications={this.props.unknownQualifications}
            errors={this.props.errors}
            errorActiveField={this.props.errorActiveField}
            inputLanguage={this.props.inputLanguage}
            handleSetStep={this.handleSetStep}
            handleChange={this.props.handleChange}
            handleSet={this.props.handleSet}
            handleLoadManualQualification={this.handleLoadManualQualification}
            handleClearActiveErrors={this.props.handleClearActiveErrors} />
        }
        {this.state.step === STEP_QUALIFICATION_CREATE &&
          <QualificationsCreateStep
            manualQualificationId={this.props.manualQualificationId}
            qualificationTitle_en={this.props.qualificationTitle_en}
            qualificationTitle_cy={this.props.qualificationTitle_cy}
            qualificationType={this.props.qualificationType}
            qualificationLevel={this.props.qualificationLevel}
            awardingBody={this.props.awardingBody}
            errors={this.props.errors}
            errorActiveField={this.props.errorActiveField}
            inputLanguage={this.props.inputLanguage}
            handleSetStep={this.handleSetStep}
            handleChange={this.props.handleChange}
            handleSet={this.props.handleSet}
            handleSaveManualQualification={this.handleSaveManualQualification}
            handleClearManualQualification={this.handleClearManualQualification}
            handleScrollTop={this.props.handleScrollTop}
            handleClearActiveErrors={this.props.handleClearActiveErrors} />
        }
      </Fragment>
    );
  }

}

export default withAssets(withTranslation('local')(CoursesQualificationsForm));
